import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { addMonths, format } from 'date-fns';
import { finalize } from 'rxjs';
import { FunctionsService } from 'src/app/data/functions.service';
import { AdicionaProdutoVendedorComponent } from '../adiciona-produto-vendedor/adiciona-produto-vendedor.component';
import { AdicionaNegociacaoComponent } from '../adiciona-negociacao/adiciona-negociacao.component';
import { slugProdutoNome } from 'src/app/commons/produto-slug.util';

@Component({
  selector: 'app-product-card',
  standalone: false,
  // imports: [],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent implements OnInit {

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private functions: FunctionsService,
  ) { }
  ngOnInit(): void {
    this.fetchFavoritesEans()
  }
  @Input() fetchingData: boolean = false;
  @Input() totalProdutos: number = 0;
  @Input() compatiblesPartsVehicle: string[] = [];
  @Input() produtos: {
    marca: { nome: string },
    nome: string,
    imagem: { url: string },
    dimenssoes: { comprimento: number; altura: number; largura: number; peso: number },
    ean: string,
    negociacoes_ativas?: number,
    averageRating?: number,
    totalReviews?: number,
  }[];

  @Output() onLoadMore = new EventEmitter<void>();

  // favoritos: string[] = [];

  eans: string[] = []

  imagemPadrao = './assets/images/watch.svg';
  isLoadingEans = false;

  detalhes(produto: any) {
    this.router.navigate(['/produto', produto?.ean, `${slugProdutoNome(produto?.nome)}.html`]);
  }

  negociacoes(produto: any) {
    this.router.navigateByUrl(`/negociacoes?ean=${produto.ean}&data_fim=${format(addMonths(new Date(), -6), 'yyyy-MM-dd 00:00:00')}`);
  }
  fetchFavoritesEans() {
    this.functions.getAllFavoriteEans().pipe(
      finalize(() => {
        this.isLoadingEans = false;
      })
    )
      .subscribe({
        next: (response) => {
          if (response.ok) {

            const eans = response.body.data.eans || [];

            this.eans = Array.from(new Set(eans.map(f => f)));

            // this.cdr.detectChanges();
          }
        },
        error: (err) => {

        }
      })

  }

  isMyFavorite(ean: string): boolean {
    return this.eans.includes(ean);
  }

  toggleFavorite(produto: any): void {
    const ean = produto?.ean;
    if (!ean) return;

    const index = this.eans.indexOf(ean);

    if (index > -1) {
      this.eans.splice(index, 1);
    } else {
      this.eans.push(ean);
    }

    this.setFavorite(ean);

    // Cria uma nova referência para o array (importante!)
    this.eans = [...this.eans];
  }

  setFavorite(ean: string) {
    if (this.eans?.includes?.(ean)) {
      this.functions.clientRemoveFavorite({ ean }).pipe(
        finalize(() => {

        })
      ).subscribe({
        next: (res) => {
          if (res.ok) {
            this.fetchFavoritesEans()
          }
        }
      })
      return
    }
    this.functions.clientAddFavorite({ ean }).pipe(
      finalize(() => {

      })
    ).subscribe({
      next: (res) => {
        if (res.ok) {
          this.fetchFavoritesEans();
        }
      }
    })
  }

  avaliacoes(produto: any) {
    console.trace('Avaliação do produto', produto);
  }

  wantToBuy(product: any) {
    const dialogRef = this.dialog.open(AdicionaNegociacaoComponent, {
      panelClass: 'white-panel',
      data: product,
    });
  }

  wantToSell(product: any) {
    const dialogRef = this.dialog.open(AdicionaProdutoVendedorComponent, {
      panelClass: 'white-panel',
      data: product,
    });

  }

  fetchData() {
    this.onLoadMore.emit();
  }

  isCompatibleWithMineVehicle(ean: string) {
    return this.compatiblesPartsVehicle.filter(f => f === ean).length > 0
  }

}
